import OrderInfoSection from './OrderInfoSection';
import OrderMethodDetailsSection from './OrderMethodDetailsSection';
import useForm from '../../../hooks/utility/useForm';
import useAuth from '../../../hooks/global/useAuth';
import CustomerInfoSection from './CustomerInfoSection';
import PaymentInfoSection from './PaymentInfoSection';
import useOrderFlow from '../../../hooks/order/useOrderFlow';
import InvoiceInfoSection from './InvoiceInfoSection';
import RememberMeSection from './RememberMeSection';
import { forwardRef, useImperativeHandle } from 'react';
import MarketingSubscriptionSection from './MarketingSubscriptionSection';
import PaymentInitializer from '../../payment/PaymentInitializer';
import usePaymentFlow from '../../../hooks/payment/usePaymentFlow';

export enum SectionType {
  order_method_details = 'order_method_details',
  customer_info = 'customer_info',
  payment_info = 'payment_info',
  invoice_info = 'invoice_info',
  remember_me = 'remember_me',
}

export type CheckoutInfoBagHandle = {
  toggleSection: (section: SectionType, open: boolean) => void;
};

const CheckoutInfoBag = forwardRef<CheckoutInfoBagHandle>((_props, ref: any) => {
  useImperativeHandle(ref, () => ({ toggleSection }));

  const { isGuest } = useAuth();
  const { data, isCustomerInfoComplete } = useOrderFlow();
  const { selectedPaymentMethod } = usePaymentFlow();

  const { data: openSections, update: updateSection } = useForm({
    [SectionType.order_method_details]: false,
    [SectionType.customer_info]: isGuest || !isCustomerInfoComplete,
    [SectionType.payment_info]: data.total > 0,
    [SectionType.invoice_info]: isGuest && data.total > 0,
  });

  function toggleSection(section: SectionType, open: boolean): void {
    updateSection(section, open);
    open &&
      document.getElementById(section)?.scrollIntoView({
        behavior: 'smooth',
      });
  }

  return (
    <>
      <OrderInfoSection toggleSection={toggleSection} />
      <OrderMethodDetailsSection show={openSections.order_method_details} />
      <CustomerInfoSection show={openSections.customer_info} />
      <MarketingSubscriptionSection />
      <RememberMeSection show={isGuest} />
      <PaymentInitializer>
        <PaymentInfoSection show={openSections.payment_info || (data.total > 0 && !selectedPaymentMethod)} />
      </PaymentInitializer>
      <InvoiceInfoSection show={openSections.invoice_info} />
    </>
  );
});

export default CheckoutInfoBag;
